import React from "react";
import styled from "styled-components";
import { BULK_SELECT_COLUMN_WIDTH } from "components/common/EntityDataTable/Constants";
const StyledCell = styled.td`
  &&& {
    width: ${BULK_SELECT_COLUMN_WIDTH}px;
    min-width: auto;
  }
`;
const BulkSelectCell = ({ children = null }) => /* @__PURE__ */ React.createElement(StyledCell, { onClick: (event) => event.stopPropagation() }, children);
export default BulkSelectCell;
